export const BUTTON_ICON_CLASS = 'cmp-button__icon'
export const BUTTON_HIDDEN_CLASS = 'cmp-video-wrapper__play-button--hidden'
export const HIDDEN_ICON_CLASS = 'cmp-button__icon--hidden'
export const CONTROL_CLASS = 'cmp-video-wrapper__controls--control'
export const PLAY_VIDEO_BUTTON_CLASS = 'cmp-video-wrapper__play-button'
export const ICON_SOUND_CLASS = 'cmp-button__icon--sound'
export const ICON_NO_SOUND_CLASS = 'cmp-button__icon--no-sound'
export const VIDEO_CURRENT_TIME_CLASS = 'cmp-video-time__current'
export const VIDEO_DURATION_TIME_CLASS = 'cmp-video-time__duration'
export const VIDEO_PROGRESS_BAR_PROGRESS_CLASS = 'cmp-video-wrapper__progress-bar--progress'
export const VIDEO_PROGRESS_BAR_CURRENT_TIME_CLASS = 'cmp-video-wrapper__progress-bar--current-time'
export const VIDEO_PROGRESS_BAR_HOVER_CLASS = 'cmp-video-wrapper__progress-bar--hover-time'
export const VIDEO_PROGRESS_BAR_BUFFER_CLASS = 'cmp-video-wrapper__progress-bar--buffer'
export const VIDEO_WRAPPER_POSTER_IMAGE_CLASS = 'cmp-video-wrapper__poster-img'
export const VIDEO_EMBED_CLASS = 'cmp-videoembed'
export const VIDEO_EMBED_POSTER_OVERLAY_CLASS = 'cmp-videoembed__poster-overlay'
